const mapResource = (rawResource) => {
    switch (rawResource) {
        case 'admins':
        case 'agents':
        case 'employees':
            return 'users';
        case 'eligibility_guides':
        case 'rate_bulletins':
        case 'underwriting_guidelines':
        case 'program_guides':
            return 'guides';
        case 'rsm_agent360':
            return 'simple_pages';
        case 'contact_forms':
            return 'form_entries';
        case 'redirects':
            return 'redirect_records';
        case 'impacted_policies':
            return 'impacting_policies';
        default:
            return rawResource;
    }
};

export default mapResource;
